import React, { useEffect, useMemo } from "react";

import { Paper, Tab, Tabs } from "@material-ui/core";
import { Link, Route, Switch, useRouteMatch } from "react-router-dom";

import { getSettingsRoute } from "lib/navigation";

import history from "appHistory";
import { useGetSelectedTabFromRoute } from "hooks/useGetSelectedTabFromRoute";
import { SaleStatuses } from "containers/Settings/Statuses/SaleStatuses";

export const StatusSettings = () => {
  const match = useRouteMatch();

  const tabs = useMemo(
    () => [
      {
        label: "Sale Statuses",
        component: SaleStatuses,
      },
    ],
    [],
  );

  const currentTab = useGetSelectedTabFromRoute(tabs);

  useEffect(() => {
    // If we aren't on a tab, open the first.
    if (!currentTab && tabs[0]?.label) {
      history.push(getSettingsRoute(`Statuses/${tabs[0].label}`));
    }
  }, [currentTab, match.path, tabs]);

  return (
    <>
      <Paper>
        <Tabs value={currentTab} variant="scrollable">
          {tabs.map(({ label }) => (
            <Tab
              label={label}
              key={label}
              value={label}
              data-tour={label}
              component={Link}
              to={label}
            />
          ))}
        </Tabs>
      </Paper>

      <Switch>
        {tabs.map(({ label, component }) => (
          <Route
            key={label}
            path={`${match.path}${label}`}
            component={component}
          />
        ))}
      </Switch>
    </>
  );
};
